<div class="layout-topbar-start">
    <a class="layout-topbar-logo" [routerLink]="['/private/dashboard']">
        <img src="layout/images/logo/logo_cotagov_topbar.png" alt="logo" class="logo-topbar" />
    </a>
    <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()">
        <i class="pi pi-chevron-right"></i>
    </a>

    <a #mobileMenuButton class="layout-topbar-mobile-button" (click)="onTopbarMenuToggle()">
        <i class="pi pi-ellipsis-v"></i>
    </a>
</div>

<div class="layout-topbar-end">
    <div class="layout-topbar-actions-start">
        <p-megamenu [model]="model" styleClass="layout-megamenu" breakpoint="0px"></p-megamenu>
    </div>
    <div class="layout-topbar-actions-end">
        <ul class="layout-topbar-items">
            <li class="layout-topbar-search">
                <a pStyleClass="@next" enterFromClass="!hidden" enterActiveClass="animate-scalein" leaveToClass="!hidden"
                    leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true" (click)="focusSearchInput()"
                    class="effect-rounding-button">
                    <i class="pi pi-search"></i>
                </a>

                <div #searchPanel class="layout-search-panel !hidden p-input-filled">
                    <i class="pi pi-search"></i>
                    <input
                        #searchInput
                        type="text"
                        pInputText
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onSearchChange()"
                        [placeholder]="'components.topbarSearch.placeholder' | translate"
                        autocomplete="off"
                    />
                    <button
                        pButton
                        pRipple
                        type="button"
                        icon="pi pi-times"
                        rounded
                        text
                        pStyleClass=".layout-search-panel"
                        leaveToClass="!hidden"
                        leaveActiveClass="animate-fadeout"
                        (click)="clearSearch()"
                    ></button>

                    <div class="layout-search-results" *ngIf="searchTerm?.trim()">
                        <button
                            type="button"
                            class="layout-search-result"
                            *ngFor="let result of searchResults"
                            (click)="selectSearchResult(result, $event)"
                        >
                            <i [class]="result.icon"></i>
                            <span class="layout-search-result-text">
                                <strong>{{ result.label }}</strong>
                                <small *ngIf="result.modulo">{{ result.modulo }}</small>
                            </span>
                        </button>
                        <div class="layout-search-empty" *ngIf="!searchResults.length">
                            {{ 'components.topbarSearch.empty' | translate }}
                        </div>
                    </div>
                </div>
            </li>
            <!-- <li>
                <button class="app-config-button" (click)="toggleConfigSidebar()">
                    <i class="pi pi-cog"></i>
                </button>
            </li> -->
            <li>
                <a pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true"
                    (click)="refreshNotificationsOnAction()">
                    <p-overlay-badge [value]="unreadNotificationsCount || null" severity="warn">
                        <i class="pi pi-bell !align-middle"></i>
                    </p-overlay-badge>
                </a>
                <div class="hidden layout-notifications-panel">
                    <ul class="list-none p-0 m-0">
                        <ng-container *ngIf="notifications.length; else emptyNotifications">
                            <li class="px-4 py-2 layout-notifications-header">
                                <span *ngIf="unreadNotificationsCount > 0"
                                    [innerHTML]="'components.topbarNotifications.newCount' | translate:{ count: unreadNotificationsCount }"></span>
                                <span *ngIf="unreadNotificationsCount === 0">
                                    {{ 'components.topbarNotifications.noNew' | translate }}
                                </span>
                            </li>
                            <li class="p-4 layout-notification-item"
                                *ngFor="let notificacao of notifications"
                                [class.is-unread]="isNotificationUnread(notificacao)"
                                [class.is-read]="!isNotificationUnread(notificacao)"
                                (click)="openNotificationOnAction(notificacao, $event)">
                                <div class="flex items-center">
                                    <div class="layout-notification-icon">
                                        <i [class]="getNotificationIcon(notificacao)"></i>
                                    </div>
                                    <div class="flex flex-col ml-4 flex-1">
                                        <div class="flex items-center justify-between mb-1 gap-2">
                                            <span class="font-bold">{{ notificacao.titulo }}</span>
                                            <small>{{ formatNotificationDate(notificacao.dataCriacao) }}</small>
                                        </div>
                                        <span class="text-sm leading-normal">{{ notificacao.descricao }}</span>
                                    </div>
                                </div>
                            </li>
                            <li class="px-4 py-2 layout-notifications-footer">
                                <a class="cursor-pointer" (click)="openAllNotificationsOnAction($event)">
                                    {{ 'components.topbarNotifications.viewAll' | translate }}
                                </a>
                            </li>
                        </ng-container>
                        <ng-template #emptyNotifications>
                            <li class="px-4 py-3 layout-notifications-empty">
                                {{ 'components.topbarNotifications.empty' | translate }}
                            </li>
                        </ng-template>
                    </ul>
                </div>
            </li>
            <li>
                <a pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                    <img src="images/avatar/avatar_default.png" alt="avatar" class="w-8 h-8" />
                </a>
                <div class="hidden">
                    <ul class="list-none p-0 m-0">
                        <li>
                            <a class="cursor-pointer flex items-center hover:bg-emphasis duration-150 transition-all px-4 py-2" pRipple
                                (click)="toggleConfigSidebar()">
                                <i class="pi pi-cog mr-2"></i>
                                <span>Configurações</span>
                            </a>
                        </li>
                        <li>
                            <a class="cursor-pointer flex items-center hover:bg-emphasis duration-150 transition-all px-4 py-2" pRipple
                                (click)="openProfileOnAction()">
                                <i class="pi pi-file-o mr-2"></i>
                                <span>Perfil</span>
                            </a>
                        </li>
                        <li *ngIf="canChangeTenant">
                            <a class="cursor-pointer flex items-center hover:bg-emphasis duration-150 transition-all px-4 py-2" pRipple
                                (click)="openChangeTenantOnAction()">
                                <i class="pi pi-building mr-2"></i>
                                <span>{{ 'components.changeTenantModal.menuLabel' | translate }}</span>
                            </a>
                        </li>
                        <li>
                            <a class="cursor-pointer flex items-center hover:bg-emphasis duration-150 transition-all px-4 py-2" pRipple>
                                <i class="pi pi-compass mr-2"></i>
                                <span>Suporte</span>
                            </a>
                        </li>
                        <li>
                            <a class="cursor-pointer flex items-center hover:bg-emphasis duration-150 transition-all px-4 py-2" pRipple
                                (click)="logoutOnAction()">
                                <i class="pi pi-power-off mr-2"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</div>